import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import { OPACITY_100 } from 'constants/opacity';
import { WHITE } from 'styles/theme/colors';

export function getAppBarOwnState() {
  return theme => {
    const backgroundColor =
      calculateRgbaWithAlpha(
        theme.palette.header.background.main,
        OPACITY_100
      ) ?? WHITE;

    return {
      backgroundColor
    };
  };
}
